var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgeSideBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 351,
    viewBox: "0 0 475 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.884 71.3877L132.791 79.5251L67.7046 41.9441L81.7975 33.8066L146.884 71.3877Z",
    fill: "url(#paint0_linear)",
    style: {
      mixBlendMode: "lighten"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1795 146.436L65.0866 154.573L0 116.992L14.0929 108.854L79.1795 146.436Z",
    fill: "url(#paint1_linear)",
    style: {
      mixBlendMode: "lighten"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.89 54.8067L160.798 62.9441L95.7109 25.363L109.804 17.2256L174.89 54.8067Z",
    fill: "url(#paint2_linear)",
    style: {
      mixBlendMode: "lighten"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.896 38.2217L188.803 46.3591L123.717 8.77806L137.81 0.640625L202.896 38.2217Z",
    fill: "url(#paint3_linear)",
    style: {
      mixBlendMode: "lighten"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.217 37.5811L257.137 45.7185L192.05 8.13743L206.143 0L271.217 37.5811Z",
    fill: "url(#paint4_linear)",
    style: {
      mixBlendMode: "lighten"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M321.274 241.851L320.889 241.62L237.191 193.309L276.98 170.424L277.365 170.642L361.05 218.966L321.274 241.851ZM240.272 193.309L321.274 240.016L357.969 218.966L276.967 172.195L240.272 193.309Z",
    fill: "#1A35C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.967 26.043V121.356L359.51 169.013V73.7124L276.967 26.043ZM286.825 43.1136L349.716 79.3983V151.955L286.825 115.67V43.1136Z",
    fill: "url(#paint5_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.686 32.5107V127.824L348.228 175.481V80.1673L265.686 32.5107ZM275.53 49.5814L338.422 85.8533V158.423L275.53 122.138V49.5814Z",
    fill: "url(#paint6_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M265.673 32.5117L276.968 26.0557L359.51 73.6994L348.215 80.1683L265.673 32.5117Z",
    fill: "url(#paint7_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359.51 73.6982L348.215 80.1671V175.48L359.51 169.011V73.6982Z",
    fill: "url(#paint8_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M286.825 115.669L275.517 122.138V49.5811L286.812 56.1013L286.825 115.669Z",
    fill: "url(#paint9_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M286.825 115.67L275.517 122.139L338.358 158.424V145.434L286.825 115.67Z",
    fill: "url(#paint10_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M281.575 118.673V53.1113L338.358 85.8536V150.915L281.575 118.673Z",
    fill: "#7BDAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.04 41.5732V136.886L332.582 184.543V89.2298L250.04 41.5732ZM259.885 58.6439L322.776 94.9286V167.485L259.885 131.2V58.6439Z",
    fill: "url(#paint11_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M238.732 48.043V143.356L321.274 191.013V95.6996L238.732 48.043ZM248.589 65.1136L311.481 101.385V173.955L248.589 137.67V65.1136Z",
    fill: "url(#paint12_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M238.732 48.0421L250.04 41.5732L332.582 89.2298L321.274 95.6987L238.732 48.0421Z",
    fill: "url(#paint13_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M332.582 89.2295L321.274 95.6984V191.012L332.582 184.543V89.2295Z",
    fill: "url(#paint14_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.884 131.2L248.589 137.669V65.1123L259.884 71.6325V131.2Z",
    fill: "url(#paint15_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M259.884 131.201L248.589 137.67L311.43 173.955V160.966L259.884 131.201Z",
    fill: "url(#paint16_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.635 134.203V68.6416L311.43 101.384V166.445L254.635 134.203Z",
    fill: "#7BDAFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M321.274 95.6985L238.732 48.0419L240.683 46.9766L323.225 94.6332V189.946L321.274 191.012V95.6985Z",
    fill: "#A9EBFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M348.215 80.1682L265.673 32.5116L267.611 31.4463L350.153 79.1029V174.416L348.215 175.481V80.1682Z",
    fill: "#A9EBFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M248.589 65.1123L250.527 66.229V136.604L311.43 171.759V173.954L248.589 137.669V65.1123Z",
    fill: "#A9EBFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.04 41.5723L265.673 32.5107L348.215 80.1673V175.48L332.582 184.542V89.2289L250.04 41.5723Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.215 80.1673L332.582 89.2289L250.04 41.5723L265.673 32.5107L348.215 80.1673Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M205.194 311.519L287.261 264.132L205.194 216.745L123.114 264.132L205.194 311.519Z",
    fill: "#041860"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 258.166L287.737 210.509V173.903L205.194 221.56V258.166Z",
    fill: "url(#paint17_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 221.558L287.736 173.902L205.194 126.245L122.651 173.902L205.194 221.558Z",
    fill: "url(#paint18_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.193 210.186L268.034 173.902L205.193 137.63L142.353 173.902L205.193 210.186Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M122.651 210.509L205.194 258.166V221.56L122.651 173.903V210.509Z",
    fill: "url(#paint19_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 199.316L287.737 151.659V115.054L205.194 162.71V199.316Z",
    fill: "url(#paint20_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 162.711L287.736 115.054L205.194 67.3975L122.651 115.054L205.194 162.711Z",
    fill: "url(#paint21_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 160.874L286.144 114.129L287.736 115.053L205.194 162.71L122.651 115.053L124.23 114.129L205.194 160.874Z",
    fill: "#A9EBFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 219.723L286.144 172.99L287.736 173.902L205.194 221.558L122.651 173.902L124.23 172.99L205.194 219.723Z",
    fill: "#A9EBFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 85.623L263.029 119.02L205.194 152.417L147.347 119.02L205.194 85.623Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 85.6236L147.346 119.02L140.467 115.054L205.194 77.6787L269.908 115.054L263.042 119.02L205.194 85.6236Z",
    fill: "#2573BA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.651 151.659L205.194 199.316V162.71L122.651 115.054V151.659Z",
    fill: "url(#paint22_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.379 164.379C176.47 166.016 176.945 167.61 177.766 169.03C178.586 170.45 179.729 171.657 181.102 172.555C183.669 174.056 185.826 172.837 185.826 169.821C185.726 168.196 185.246 166.617 184.426 165.21C183.606 163.804 182.467 162.609 181.102 161.722C178.497 160.143 176.379 161.362 176.379 164.379Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M159.154 154.457C159.245 156.095 159.72 157.688 160.541 159.109C161.361 160.529 162.504 161.736 163.878 162.633C166.445 164.135 168.601 162.916 168.601 159.9C168.511 158.263 168.036 156.671 167.215 155.253C166.395 153.835 165.251 152.63 163.878 151.736C161.311 150.171 159.154 151.454 159.154 154.457Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M142.02 144.536C142.109 146.173 142.581 147.766 143.4 149.186C144.218 150.606 145.359 151.814 146.73 152.712C149.297 154.214 151.454 152.994 151.454 149.978C151.364 148.342 150.889 146.75 150.068 145.332C149.248 143.913 148.104 142.708 146.73 141.815C144.125 140.3 142.02 141.52 142.02 144.536Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M178.779 161.041C178.528 161.629 178.406 162.263 178.42 162.902C178.511 164.54 178.986 166.133 179.806 167.553C180.627 168.974 181.77 170.181 183.143 171.078C183.838 171.51 184.648 171.721 185.466 171.681C184.76 173.26 183.079 173.684 181.102 172.554C179.729 171.657 178.586 170.45 177.766 169.029C176.945 167.609 176.47 166.016 176.379 164.378C176.379 162.35 177.354 161.157 178.779 161.041Z",
    fill: "#A9EBFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M161.593 151.121C161.342 151.709 161.22 152.343 161.234 152.982C161.325 154.62 161.8 156.213 162.62 157.633C163.441 159.054 164.584 160.261 165.957 161.158C166.652 161.59 167.463 161.801 168.28 161.761C167.574 163.34 165.893 163.764 163.916 162.634C162.543 161.737 161.4 160.53 160.58 159.109C159.759 157.689 159.284 156.096 159.193 154.458C159.154 152.43 160.168 151.237 161.593 151.121Z",
    fill: "#A9EBFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M144.407 141.187C144.157 141.774 144.034 142.409 144.048 143.048C144.139 144.685 144.614 146.279 145.435 147.699C146.255 149.119 147.398 150.326 148.771 151.224C149.466 151.656 150.277 151.866 151.094 151.827C150.388 153.406 148.707 153.829 146.73 152.7C145.359 151.802 144.218 150.594 143.4 149.174C142.581 147.753 142.109 146.16 142.02 144.524C142.02 142.47 142.983 141.315 144.407 141.187Z",
    fill: "#A9EBFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M176.379 223.241C176.469 224.877 176.944 226.469 177.764 227.887C178.585 229.305 179.729 230.51 181.102 231.404C183.669 232.918 185.826 231.699 185.826 228.683C185.734 227.045 185.259 225.452 184.439 224.031C183.618 222.611 182.475 221.404 181.102 220.507C178.497 219.005 176.379 220.224 176.379 223.241Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M159.154 213.319C159.244 214.955 159.719 216.547 160.54 217.965C161.36 219.383 162.504 220.588 163.878 221.482C166.445 222.996 168.601 221.777 168.601 218.761C168.51 217.123 168.035 215.53 167.214 214.11C166.394 212.689 165.251 211.482 163.878 210.585C161.311 209.083 159.154 210.303 159.154 213.319Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M142.02 203.397C142.108 205.032 142.58 206.624 143.398 208.042C144.217 209.46 145.359 210.666 146.73 211.56C149.297 213.075 151.454 211.855 151.454 208.839C151.363 207.201 150.888 205.608 150.067 204.188C149.247 202.767 148.104 201.56 146.73 200.663C144.125 199.161 142.02 200.381 142.02 203.397Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M178.779 219.902C178.527 220.49 178.405 221.124 178.42 221.763C178.51 223.4 178.984 224.991 179.805 226.41C180.626 227.828 181.769 229.033 183.143 229.927C183.835 230.367 184.647 230.582 185.466 230.543C184.76 232.121 183.079 232.545 181.102 231.403C179.729 230.509 178.585 229.304 177.764 227.886C176.944 226.468 176.469 224.876 176.379 223.239C176.379 221.212 177.354 220.018 178.779 219.902Z",
    fill: "#A9EBFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M161.593 209.981C161.341 210.569 161.218 211.204 161.234 211.843C161.324 213.479 161.798 215.071 162.619 216.489C163.44 217.907 164.583 219.112 165.957 220.006C166.649 220.446 167.461 220.662 168.28 220.622C167.574 222.2 165.893 222.624 163.916 221.482C162.535 220.592 161.384 219.389 160.557 217.971C159.729 216.552 159.249 214.958 159.154 213.319C159.154 211.291 160.168 210.097 161.593 209.981Z",
    fill: "#A9EBFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M144.407 200.06C144.155 200.647 144.033 201.282 144.048 201.921C144.138 203.557 144.613 205.149 145.433 206.567C146.254 207.985 147.398 209.19 148.771 210.084C149.463 210.524 150.275 210.74 151.094 210.7C150.388 212.279 148.707 212.702 146.73 211.56C145.359 210.666 144.217 209.46 143.398 208.042C142.58 206.623 142.108 205.032 142.02 203.397C142.02 201.369 142.983 200.226 144.407 200.06Z",
    fill: "#A9EBFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 138.414L287.737 90.7573V75.8301L205.194 123.487V138.414Z",
    fill: "url(#paint23_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 123.486L287.736 75.8294L205.194 28.1729L122.651 75.8294L205.194 123.486Z",
    fill: "url(#paint24_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M205.194 121.65L286.144 74.918L287.736 75.8293L205.194 123.486L122.651 75.8293L124.23 74.918L205.194 121.65Z",
    fill: "#A9EBFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M122.651 90.7573L205.194 138.414V123.487L122.651 75.8301V90.7573Z",
    fill: "url(#paint25_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M287.737 151.659V173.902L205.194 221.559V199.316L287.737 151.659Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.651 151.659V173.902L205.194 221.559V199.316L122.651 151.659Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M236.807 225.73L256.06 214.589C257.001 213.915 257.771 213.03 258.308 212.005C258.845 210.979 259.135 209.842 259.153 208.685C259.153 206.4 257.767 205.361 256.06 206.349L236.807 217.49C235.867 218.164 235.098 219.049 234.563 220.075C234.028 221.1 233.741 222.237 233.727 223.394C233.727 225.666 235.1 226.718 236.807 225.73Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M252.85 212.497C253.792 211.821 254.563 210.934 255.1 209.906C255.637 208.878 255.926 207.739 255.944 206.58V206.464L256.149 206.349C257.856 205.361 259.242 206.349 259.242 208.685C259.224 209.842 258.934 210.979 258.397 212.005C257.86 213.03 257.09 213.915 256.149 214.589L236.896 225.73C235.228 226.705 233.867 225.73 233.816 223.522L252.85 212.497Z",
    fill: "url(#paint26_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M129.634 351L45.564 302.458L85.3527 279.573L169.422 328.128L129.634 351ZM48.6444 302.458L129.634 349.229L166.329 328.115L85.3398 281.357L48.6444 302.458Z",
    fill: "#1A35C2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3403 135.204V230.517L167.883 278.174V182.861L85.3403 135.204ZM95.1977 152.275L158.089 188.547V261.103L95.1977 224.831V152.275Z",
    fill: "url(#paint27_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0454 141.673V236.986L156.588 284.643V189.329L74.0454 141.673ZM83.8899 158.731L146.782 195.015V267.572L83.8899 231.3V158.731Z",
    fill: "url(#paint28_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0454 141.673L85.3403 135.204L167.883 182.861L156.588 189.33L74.0454 141.673Z",
    fill: "url(#paint29_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M167.883 182.861L156.588 189.33V284.643L167.883 278.175V182.861Z",
    fill: "url(#paint30_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1973 224.833L83.8896 231.302V158.732L95.1845 165.253L95.1973 224.833Z",
    fill: "url(#paint31_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1973 224.831L83.8896 231.3L146.73 267.572L146.743 254.583L95.1973 224.831Z",
    fill: "url(#paint32_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M89.9482 227.834V162.26L146.731 195.015V260.076L89.9482 227.834Z",
    fill: "#7BDAFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4121 150.736V246.05L140.954 293.706V198.393L58.4121 150.736ZM68.2566 167.794L131.148 204.079V276.635L68.2566 240.364V167.794Z",
    fill: "url(#paint33_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1045 157.204V252.517L129.634 300.174V204.861L47.1045 157.204ZM56.9618 174.262L119.854 210.547V283.103L56.9618 246.819V174.262Z",
    fill: "url(#paint34_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1045 157.205L58.4122 150.736L140.954 198.393L129.647 204.862L47.1045 157.205Z",
    fill: "url(#paint35_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M140.954 198.392L129.646 204.86V300.174L140.954 293.705V198.392Z",
    fill: "url(#paint36_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2563 240.362L56.9614 246.831V174.262L68.2563 180.782V240.362Z",
    fill: "url(#paint37_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2563 240.362L56.9614 246.831L119.802 283.103V270.114L68.2563 240.362Z",
    fill: "url(#paint38_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.0073 243.366V177.792L119.802 210.547V275.608L63.0073 243.366Z",
    fill: "#7BDAFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M129.647 204.862L47.1045 157.205L49.0554 156.127L131.598 203.796V299.097L129.647 300.175V204.862Z",
    fill: "#A9EBFF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M156.588 189.329L74.0454 141.673L75.9835 140.607L158.539 188.264V283.564L156.588 284.643V189.329Z",
    fill: "#A9EBFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9614 174.262L58.9124 175.391V245.753L119.802 280.908V283.103L56.9614 246.831V174.262Z",
    fill: "#A9EBFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.4121 150.734L74.0452 141.673L156.588 189.329V284.643L140.954 293.704V198.391L58.4121 150.734Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M156.588 189.329L140.954 198.391L58.4121 150.734L74.0452 141.673L156.588 189.329Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M240.632 229.197C240.647 228.128 240.912 227.078 241.407 226.13C241.902 225.183 242.613 224.365 243.481 223.742L261.271 213.474C261.548 213.274 261.877 213.158 262.218 213.14C262.56 213.122 262.899 213.202 263.196 213.371L282.834 224.73L261.194 242.815L241.582 231.482C241.244 231.212 240.979 230.861 240.813 230.461C240.647 230.062 240.585 229.627 240.632 229.197Z",
    fill: "url(#paint39_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M263.119 242.672L280.895 232.404C281.767 231.786 282.48 230.971 282.978 230.026C283.475 229.08 283.742 228.03 283.757 226.962C283.757 224.857 282.474 223.894 280.895 224.806L263.119 235.074C262.248 235.696 261.536 236.513 261.039 237.461C260.542 238.408 260.274 239.459 260.256 240.529C260.205 242.582 261.489 243.571 263.119 242.672Z",
    fill: "url(#paint40_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M278.687 261.244L307.681 244.507V231.634L278.687 248.384V261.244Z",
    fill: "url(#paint41_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M278.687 248.385L307.682 231.635L278.687 214.898L249.68 231.635L278.687 248.385Z",
    fill: "url(#paint42_linear)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M249.68 244.507L278.687 261.244V248.384L249.68 231.634V244.507Z",
    fill: "url(#paint43_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M278.687 247.742L307.13 231.313L307.682 231.634L278.687 248.384L249.68 231.634L250.245 231.313L278.687 247.742Z",
    fill: "#A9EBFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M284.271 250.67L301.098 240.838L315.281 252.197L316.474 261.99V270.923L382.87 310.917L396.86 319.183L394.73 325.575L385.001 329.451L371.537 325.447L337.472 304.128L307.682 287.583L299.339 281.191L298.813 267.586L297.748 259.32L284.271 250.67Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M384.282 331.697C387.113 331.689 389.893 330.936 392.342 329.515C394.813 328.121 396.868 326.094 398.294 323.641C399.72 321.188 400.465 318.4 400.454 315.563V153.135C400.411 152.58 400.161 152.062 399.753 151.684C399.345 151.306 398.809 151.096 398.253 151.096C397.696 151.096 397.16 151.306 396.752 151.684C396.344 152.062 396.094 152.58 396.051 153.135V315.563C396.052 317.618 395.511 319.637 394.484 321.416C393.457 323.196 391.979 324.674 390.2 325.702C388.42 326.73 386.401 327.271 384.346 327.271C382.291 327.271 380.273 326.73 378.493 325.703L305.461 283.488C304.203 282.757 303.157 281.708 302.43 280.447C301.703 279.186 301.318 277.756 301.316 276.3V266.225C301.305 263.99 300.706 261.797 299.579 259.866C298.453 257.935 296.839 256.335 294.898 255.225L286.709 250.502C286.457 250.358 286.178 250.265 285.889 250.229C285.6 250.192 285.307 250.213 285.027 250.29C284.746 250.367 284.483 250.498 284.253 250.677C284.023 250.855 283.831 251.077 283.687 251.33C283.543 251.583 283.45 251.861 283.413 252.15C283.377 252.439 283.398 252.732 283.475 253.013C283.552 253.293 283.683 253.556 283.861 253.786C284.04 254.016 284.262 254.208 284.515 254.352L292.703 259.076C293.962 259.807 295.008 260.856 295.735 262.117C296.462 263.378 296.847 264.808 296.849 266.263V276.339C296.854 278.568 297.443 280.757 298.558 282.687C299.673 284.617 301.274 286.221 303.203 287.339L376.234 329.553C378.682 330.961 381.458 331.7 384.282 331.697Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M300.34 241.645C300.633 241.141 301.113 240.773 301.675 240.622C302.238 240.47 302.838 240.547 303.344 240.836L311.532 245.56C313.458 246.679 315.057 248.284 316.17 250.214C317.282 252.144 317.869 254.332 317.873 256.559V266.635C317.874 268.092 318.259 269.524 318.989 270.786C319.719 272.047 320.768 273.095 322.031 273.822L398.22 317.872C399.685 318.716 401.313 319.237 402.995 319.4C402.854 320.85 402.905 322.339 402.79 323.802C400.404 323.605 398.093 322.877 396.026 321.671L319.824 277.634C317.896 276.517 316.296 274.913 315.183 272.982C314.07 271.052 313.484 268.863 313.483 266.635V256.559C313.481 255.102 313.095 253.671 312.365 252.409C311.635 251.148 310.587 250.1 309.325 249.372L301.136 244.648C300.885 244.505 300.665 244.313 300.489 244.084C300.313 243.854 300.184 243.592 300.11 243.313C300.036 243.034 300.018 242.742 300.058 242.456C300.097 242.169 300.193 241.894 300.34 241.645Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M390.622 330.375L397.322 322.006L398.272 312.111V288.109L398.195 162.043L415.727 165.034V156.87C415.77 156.316 416.02 155.797 416.428 155.419C416.836 155.041 417.372 154.831 417.929 154.831C418.485 154.831 419.021 155.041 419.429 155.419C419.837 155.797 420.087 156.316 420.13 156.87V307.734C420.144 310.565 419.405 313.349 417.989 315.801C416.572 318.253 414.529 320.284 412.069 321.686C411.177 322.196 410.241 322.626 409.271 322.969L390.622 330.375Z",
    fill: "url(#paint44_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M384.282 331.697C387.113 331.689 389.893 330.936 392.342 329.515C394.813 328.121 396.868 326.094 398.294 323.641C399.72 321.188 400.465 318.4 400.454 315.563V153.135C400.411 152.58 400.161 152.062 399.753 151.684C399.345 151.306 398.809 151.096 398.253 151.096C397.696 151.096 397.16 151.306 396.752 151.684C396.344 152.062 396.094 152.58 396.051 153.135V315.563C396.052 317.618 395.511 319.637 394.484 321.416C393.457 323.196 391.979 324.674 390.2 325.702C388.42 326.73 386.401 327.271 384.346 327.271C382.291 327.271 380.273 326.73 378.493 325.703L305.461 283.488C304.203 282.757 303.157 281.708 302.43 280.447C301.703 279.186 301.318 277.756 301.316 276.3V266.225C301.305 263.99 300.706 261.797 299.579 259.866C298.453 257.935 296.839 256.335 294.898 255.225L286.709 250.502C286.457 250.358 286.178 250.265 285.889 250.229C285.6 250.192 285.307 250.213 285.027 250.29C284.746 250.367 284.483 250.498 284.253 250.677C284.023 250.855 283.831 251.077 283.687 251.33C283.543 251.583 283.45 251.861 283.413 252.15C283.377 252.439 283.398 252.732 283.475 253.013C283.552 253.293 283.683 253.556 283.861 253.786C284.04 254.016 284.262 254.208 284.515 254.352L292.703 259.076C293.962 259.807 295.008 260.856 295.735 262.117C296.462 263.378 296.847 264.808 296.849 266.263V276.339C296.854 278.568 297.443 280.757 298.558 282.687C299.673 284.617 301.274 286.221 303.203 287.339L376.234 329.553C378.682 330.961 381.458 331.7 384.282 331.697Z",
    fill: "url(#paint45_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M272.565 255.072L275.53 256.791V250.836L272.565 249.129V255.072Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M267.637 252.234L270.589 253.941V247.998L267.637 246.278V252.234Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M262.708 249.385L265.66 251.092V245.149L262.708 243.442V249.385Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M257.779 246.536L260.731 248.243V242.301L257.779 240.594V246.536Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M252.838 243.687L255.803 245.394V239.451L252.838 237.744V243.687Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M469.532 98.4451L445.505 84.4806C441.924 82.3371 436.931 82.6066 431.386 85.7641C429.528 86.868 427.786 88.1582 426.188 89.6146L416.511 84.0185C411.197 80.2835 403.496 80.4504 394.922 85.3919C384.115 91.6554 374.668 103.964 369.65 117.005C367.718 117.12 365.844 117.711 364.195 118.725C357.123 122.806 351.36 132.74 351.36 140.904C351.36 141.083 351.36 141.25 351.36 141.417C349.026 141.642 346.774 142.397 344.775 143.625C335.727 148.848 328.398 161.594 328.398 171.99C328.398 177.124 330.195 180.821 333.121 182.54H333.198L356.982 196.377L362.116 171.464L431.425 131.483C440.281 126.349 447.777 115.323 450.293 104.606L469.532 98.4451Z",
    fill: "url(#paint46_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M329.104 172.555C329.104 162.12 336.446 149.452 345.494 144.189C347.492 142.962 349.744 142.207 352.079 141.982C352.079 141.815 352.079 141.648 352.079 141.468C352.079 133.305 357.816 123.371 364.914 119.289C366.562 118.274 368.436 117.683 370.369 117.569C375.374 104.529 384.808 92.2201 395.654 85.9566C404.215 81.0151 411.916 80.8226 417.242 84.5832L426.92 90.1793C428.518 88.7229 430.259 87.4328 432.118 86.3288C437.637 83.1457 442.617 82.8762 446.237 85.0453L469.404 98.5093H469.609L445.505 84.4806C441.924 82.3371 436.931 82.6066 431.387 85.7641C429.528 86.868 427.786 88.1582 426.188 89.6146L416.511 84.0185C411.197 80.2835 403.496 80.4504 394.922 85.3919C384.115 91.6554 374.668 103.964 369.65 117.005C367.718 117.12 365.844 117.711 364.195 118.725C357.123 122.806 351.36 132.74 351.36 140.903C351.36 141.083 351.36 141.25 351.36 141.417C349.026 141.642 346.774 142.397 344.775 143.625C335.727 148.848 328.398 161.594 328.398 171.99C328.398 176.7 329.887 180.115 332.351 182.001C330.349 180.038 329.104 176.829 329.104 172.555Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M455.208 99.6138C451.946 101.567 449.021 104.033 446.544 106.917C442.912 95.2627 431.835 91.6433 418.744 99.2159C407.898 105.479 398.451 117.788 393.459 130.829C391.526 130.943 389.652 131.534 388.004 132.549C380.932 136.63 375.169 146.565 375.169 154.728C375.169 154.907 375.169 155.074 375.169 155.241C372.83 155.466 370.574 156.221 368.571 157.449C359.587 162.673 352.194 175.418 352.194 185.814C352.194 196.211 359.536 200.497 368.571 195.274L455.157 145.281C466.079 138.979 474.923 123.654 474.923 111.037C474.923 98.4202 466.131 93.3118 455.208 99.6138Z",
    fill: "url(#paint47_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.7,
    d: "M455.208 99.6138C451.946 101.567 449.021 104.033 446.544 106.917C442.912 95.2627 431.835 91.6433 418.744 99.2159C407.898 105.479 398.451 117.788 393.459 130.829C391.526 130.943 389.652 131.534 388.004 132.549C380.932 136.63 375.169 146.565 375.169 154.728C375.169 154.907 375.169 155.074 375.169 155.241C372.83 155.466 370.574 156.221 368.571 157.449C359.587 162.673 352.194 175.418 352.194 185.814C352.194 196.211 359.536 200.497 368.571 195.274L455.157 145.281C466.079 138.979 474.923 123.654 474.923 111.037C474.923 98.4202 466.131 93.3118 455.208 99.6138Z",
    fill: "url(#paint48_linear)"
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M455.208 99.6138C451.946 101.567 449.021 104.033 446.544 106.917C442.912 95.2627 431.835 91.6433 418.744 99.2159C407.898 105.479 398.451 117.788 393.459 130.829C391.526 130.943 389.652 131.534 388.004 132.549C380.932 136.63 375.169 146.565 375.169 154.728C375.169 154.907 375.169 155.074 375.169 155.241C372.83 155.466 370.574 156.221 368.571 157.449C359.587 162.673 352.194 175.418 352.194 185.814C352.194 196.211 359.536 200.497 368.571 195.274L455.157 145.281C466.079 138.979 474.923 123.654 474.923 111.037C474.923 98.4202 466.131 93.3118 455.208 99.6138Z",
    fill: "#0063AD"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.7,
    d: "M447.597 108.237C450.066 105.345 452.993 102.878 456.26 100.934C462.96 97.083 468.877 97.5066 472.445 101.331C469.057 96.3258 462.614 95.3375 455.208 99.6115C452.115 101.476 449.331 103.81 446.955 106.53C447.186 107.043 447.404 107.621 447.597 108.237Z",
    fill: "url(#paint49_linear)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 139.811,
    y1: 71.0163,
    x2: 107.353,
    y2: 15.0556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8DC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6D9BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5176B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#3A589D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#29418E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1D3183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#15277C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13247A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 99185.8,
    y1: 1090.89,
    x2: 99185.8,
    y2: -1560.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8DC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6D9BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5176B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#3A589D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#29418E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1D3183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#15277C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13247A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 107129,
    y1: -296.403,
    x2: 107129,
    y2: -2948.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8DC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6D9BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5176B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#3A589D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#29418E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1D3183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#15277C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13247A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 108907,
    y1: -327.618,
    x2: 108907,
    y2: -2979.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8DC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6D9BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5176B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#3A589D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#29418E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1D3183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#15277C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13247A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 111099,
    y1: 1054.27,
    x2: 111099,
    y2: -1597.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8DC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6D9BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5176B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#3A589D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#29418E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1D3183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#15277C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13247A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 381.676,
    y1: 78.41,
    x2: 246.42,
    y2: 119.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -158831,
    y1: 10432.1,
    x2: -149707,
    y2: 11296.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 354.017,
    y1: 35.5023,
    x2: 267.649,
    y2: 72.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 377.813,
    y1: 114.206,
    x2: 302.163,
    y2: 147.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: -20865.6,
    y1: 4233.2,
    x2: -20502.8,
    y2: 4263.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: -119212,
    y1: 4680.47,
    x2: -116135,
    y2: 4680.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: -157752,
    y1: 10505.5,
    x2: -148543,
    y2: 12108.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: -157126,
    y1: 12177.6,
    x2: -148002,
    y2: 13041.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -177387,
    y1: 2193.6,
    x2: -172555,
    y2: 5754.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: -21289.9,
    y1: 10377.4,
    x2: -20499.9,
    y2: 10415.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: -20631.4,
    y1: 5126.66,
    x2: -20269.1,
    y2: 5157.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: -117920,
    y1: 5213.32,
    x2: -114843,
    y2: 5213.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: -153956,
    y1: 12159.4,
    x2: -147208,
    y2: 16716.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: -304607,
    y1: 11066.3,
    x2: -293179,
    y2: 19570.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: -148942,
    y1: 13330.6,
    x2: -141809,
    y2: 15437.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: -153956,
    y1: 8237.09,
    x2: -147208,
    y2: 12794.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: -304607,
    y1: 6636.38,
    x2: -293179,
    y2: 15140.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: -148942,
    y1: 9407.49,
    x2: -141809,
    y2: 11514.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: -153624,
    y1: 3840.87,
    x2: -148816,
    y2: 8212.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: -304607,
    y1: 3685.34,
    x2: -293177,
    y2: 12188.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: -148667,
    y1: 4600.01,
    x2: -142522,
    y2: 7042.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: -46557.4,
    y1: 3468.03,
    x2: -46100.1,
    y2: 3865.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: -147326,
    y1: 21028.8,
    x2: -138117,
    y2: 22631.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: -146700,
    y1: 22700.9,
    x2: -137575,
    y2: 23564.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: -165487,
    y1: 6235.14,
    x2: -160656,
    y2: 9796.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: -19980.8,
    y1: 17896,
    x2: -19191.7,
    y2: 17934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: -19369,
    y1: 10515.1,
    x2: -19006.3,
    y2: 10545.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: -110044,
    y1: 8423.36,
    x2: -106967,
    y2: 8423.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: -145620,
    y1: 22774.3,
    x2: -136411,
    y2: 24376.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: -144972,
    y1: 24446.3,
    x2: -135849,
    y2: 25309.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: -163567,
    y1: 6905.59,
    x2: -158736,
    y2: 10467.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: -19793.4,
    y1: 19142.1,
    x2: -19003.2,
    y2: 19180.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: -19136.8,
    y1: 11408.7,
    x2: -18774.5,
    y2: 11439.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: -108730,
    y1: 8956.06,
    x2: -105653,
    y2: 8956.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 272.142,
    y1: 219.815,
    x2: 249,
    y2: 235.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3596D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2587C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0C6FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 41626.9,
    y1: 953.96,
    x2: 41254.2,
    y2: 1351.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: -54217.2,
    y1: 5645.91,
    x2: -53384.1,
    y2: 6208.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: -108323,
    y1: 6014.79,
    x2: -106912,
    y2: 7064.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: -53641.2,
    y1: 5790.41,
    x2: -52760.4,
    y2: 6050.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: -57952.3,
    y1: 33325.6,
    x2: -56819.8,
    y2: 33325.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: -227953,
    y1: 34107.7,
    x2: -217284,
    y2: 34107.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 328.462,
    y1: 138.901,
    x2: 469.532,
    y2: 138.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 353.204,
    y1: 171.6,
    x2: 476.504,
    y2: 171.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 524.699,
    y1: 204.613,
    x2: 370.491,
    y2: 133.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1A1660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1E2D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#255385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2F87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3CCACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 9930.41,
    y1: 1145.71,
    x2: 9744.18,
    y2: 799.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1A1660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1E2D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#255385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2F87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3CCACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgeSideBanner);
export default __webpack_public_path__ + "static/media/ege-side-banner.a9a7ba8c273def4dae7bd95f90041aa6.svg";
export { ForwardRef as ReactComponent };